import { __awaiter } from "tslib";
import { IS_NOT_PRODUCTION } from 'utils/env';
export const checkTestOnlyInDevRule = (rule) => __awaiter(void 0, void 0, void 0, function* () {
    return IS_NOT_PRODUCTION;
});
export const validateTestOnlyInDevRule = (rule) => {
    // always correct
    return true;
};
